<div #toastElement class="toast mt-2" role="alert" aria-live="polite" aria-atomic="true" [ngClass]="toastEvent.type">
  @if (toastEvent.title) {
    <div class="toast-header">
      <div class="me-auto">{{ toastEvent.title }}</div>
      <button type="button" class="btn-close" aria-label="Close" (click)="hide()"></button>
    </div>
  }
  <div class="toast-body border-0 content d-flex align-items-start justify-content-between gap-2">
    <span>{{ toastEvent.message }}</span>
    @if (!toastEvent.title) {
      <button type="button" data-bs-theme="dark" class="btn-close btn-sm" aria-label="Close" (click)="hide()"></button>
    }
  </div>
</div>
